/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned
 * by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { DataTable } from '@scuf/datatable';
import { Icon, Tooltip } from '@scuf/common';
import '@scuf/datatable/honeywell/theme.css';
import Moment from 'moment';
import 'moment-timezone';
import { util } from '@keystone/common';
import { withVadContext, withApplicationContext } from '../../common/HOCs';

const downloadStyle = {
  backgroundColor: '#84BD00',
  borderColor: '#84BD00',
  paddingTop: '10px',
  paddingRight: '1.5rem',
  paddingBottom: '0.5rem',
  paddingLeft: '1.5rem',
};

const formatOrderNumberCell = (data) => {
  const formattedOrderNumber = `0000000${data.rowData.orderNumber}`.slice(-7);
  return `VSLA${formattedOrderNumber}`;
};

const formatDateCell = (date) => {
  return Moment.unix(date.rowData.timeCreated).format('YYYY-MM-DD hh:mm:ss A');
};

const formatAcceptedDateCell = (data) => {
  if (data.rowData.customerResponse !== null) {
    return new Moment(data.rowData.customerResponse.dateAccepted).format('YYYY-MM-DD hh:mm:ss A');
  }
  return '';
};

/**
 * A parent component to render all SLA's
 */
class SLATable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      loading: false,
    };
  }

  async componentDidMount() {
    this.loadData();
  }

  get tableDataCount() {
    const { tableData } = this.state;
    return tableData.length;
  }

  async loadData() {
    this.setState({ loading: true });
    const data = await this.props.vadContext.fetchAllSLAs();
    this.setState({ tableData: data, loading: false });
  }

  formatStatusCell = (data) => {
    let cellData = '';
    if (data.rowData.customerResponse !== null && data.rowData.status === 'Accepted') {
      cellData = (
        <a
          onClick={() => null}
          href={`${util.getAPIGatewayURL()}/sla/downloadAcknowledgement?id_token=${
            this.props.appContext.user.idToken
          }&orderNumber=${data.rowData.orderNumber}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Accepted{' '}
          <Tooltip
            element={<Icon name="document" size="large" />}
            content="Confirmation Email"
            position="top right"
          />
        </a>
      );
    } else {
      cellData = data.rowData.status;
    }
    return <div>{cellData}</div>;
  };

  render() {
    const { tableData, loading } = this.state;
    return (
      <>
        <div className="table-wrapper">
          <DataTable
            data={tableData}
            reorderableColumns
            resizableColumns
            loading={loading}
            totalRecords={this.tableDataCount}
            search
            scrollable
            scrollHeight="600px"
          >
            <DataTable.Column
              field="orderNumber"
              header="Order Number"
              renderer={formatOrderNumberCell}
              sortable
            />
            <DataTable.Column field="customerName" header="Customer Name" sortable />
            <DataTable.Column
              field="customerEmail"
              initialWidth={250}
              header="Customer Email"
              sortable
            />
            <DataTable.Column
              field="partnerEmail"
              initialWidth={250}
              header="Partner Email"
              sortable
            />
            <DataTable.Column field="cbmemail" initialWidth={250} header="CBM Email" sortable />
            <DataTable.Column
              field="timeCreated"
              header="Creation Time"
              renderer={formatDateCell}
              sortable
            />
            <DataTable.Column
              field="customerResponse.dateAccepted"
              header="Accepted Time"
              renderer={formatAcceptedDateCell}
              sortable
            />
            <DataTable.Column
              field="status"
              header="Status"
              renderer={this.formatStatusCell}
              sortable
            />
          </DataTable>
        </div>
      </>
    );
  }
}

export default withApplicationContext(withVadContext(SLATable));
